import { getDeviceFingerprintHash } from '@/api/native/utils';
import { session } from '@/shared/utils/storage';

export default class GetDeviceFingerprintHash {
  static async getDeviceFingerprintHash(): Promise<string> {
    const riskParam = (await getDeviceFingerprintHash()) as Dictionary<string>;
    const riskParams = session.get('riskParam') || '';

    if (riskParams) {
      session.remove('riskParam');
    }

    session.set('riskParam', riskParam.fingerprintHash);

    return riskParam.fingerprintHash;
  }
}
